import { Form } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyleStoreManager = createGlobalStyle`
   & .ant-row.clear-margin {
      margin: 0px 0px !important;
    }

    & .ant-slider-handle {
        width: 10px;
        height: 21px;
        background-color: #2081FF;
        border-radius: 2px;
        margin-top: -8px;

    }
`;

export const CardInfoContainer = styled.div`
    height: 129px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    border-radius: ${({ theme }) => theme.borderRadius.default};
    overflow: hidden;
`;

export const CardInfoHeader = styled.div`
    background: ${({ theme: { theme, colors } }) =>
        theme === 'light' ? '#2081FF' : colors.componentBackground};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 61px;
    border-top-left-radius: ${({ theme }) => theme.borderRadius.default};
    border-top-right-radius: ${({ theme }) => theme.borderRadius.default};
`;

export const CardInfoFooter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-left: 2px solid
        ${({ theme: { theme, colors } }) =>
            theme === 'light' ? '#dadada' : colors.componentBackground};
    border-bottom: 2px solid
        ${({ theme: { theme, colors } }) =>
            theme === 'light' ? '#dadada' : colors.componentBackground};
    border-right: 2px solid
        ${({ theme: { theme, colors } }) =>
            theme === 'light' ? '#dadada' : colors.componentBackground};
    height: 68px;
    width: 100%;
    border-bottom-left-radius: ${({ theme }) => theme.borderRadius.default};
    border-bottom-right-radius: ${({ theme }) => theme.borderRadius.default};
`;

export const CardInfoHeaderTitle = styled.h1`
    font-size: 18px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
`;

export const CardInfoFooterTitle = styled.h1`
    font-size: 28px;
    color: #2081ff;
    font-weight: 600;
    margin: 0;
`;

export const ItemSelectedTitle = styled.h1`
    font-size: 16px;
    color: #000000;
    font-weight: 600;
`;

export const QuantityResult = styled.h2`
    font-weight: 400;
    font-size: 16px;
    color: #000000;
`;

export const Label = styled.label`
    font-size: 16px;
    font-weight: 400;
`;

export const AreaSlide = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
`;

export const LabelRange = styled.h2`
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    padding: 0;
`;

export const AreaLabel = styled.div`
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AreaExported = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 12px;

    @media only screen and (max-width: 767px) {
        & {
            flex-direction: column;
            gap: 8px;
        }
    }
`;

export const AreaListItem = styled.div`
    width: calc(100% - 227px);
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;

    @media only screen and (max-width: 767px) {
        & {
            width: 100%;
        }
    }
`;

export const ModalContainer = styled(Form)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: start;
`;
